import { create } from 'zustand';

/** H3 hex grid overlay state — toggles are independent so layers can stack */
interface H3State {
  gridVisible: boolean;
  heatVisible: boolean;
  snapUnits: boolean;
  resolution: number; // 0-15; 6-10 is typical for tactical work
  selectedCell: string | null;
  /** True when the current viewport would exceed MAX_CELLS at this resolution */
  overCellLimit: boolean;
  setGridVisible: (v: boolean) => void;
  setHeatVisible: (v: boolean) => void;
  setSnapUnits: (v: boolean) => void;
  setResolution: (r: number) => void;
  setSelectedCell: (cell: string | null) => void;
  setOverCellLimit: (v: boolean) => void;
}

/** Store for H3 hex grid overlay state */
export const useH3Store = create<H3State>((set) => ({
  gridVisible: false,
  heatVisible: false,
  snapUnits: false,
  resolution: 6,
  selectedCell: null,
  overCellLimit: false,
  setGridVisible: (gridVisible) => set({ gridVisible }),
  setHeatVisible: (heatVisible) => set({ heatVisible }),
  setSnapUnits: (snapUnits) => set({ snapUnits }),
  setResolution: (resolution) => set({ resolution }),
  setSelectedCell: (selectedCell) => set({ selectedCell }),
  setOverCellLimit: (overCellLimit) => set({ overCellLimit }),
}));
